export const VuetifyHTTPClientHints = "vuetify:nuxt:ssr-client-hints";
